import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { Button, NamedLink } from '../../../components';
import { heroStylesData } from '../../../util/pageHeroHelper';

import css from './SectionHero.module.css';
import classNames from 'classnames';

const SectionHero = props => {
  const {
    rootClassName,
    className,
    currentUser,
    isTeacher,
    handleGetStarted,
    state,
    subject,
    content,
  } = props;

  const [heroStyles, setHeroStyles] = useState({});

  useEffect(() => {

    if(subject) {
      const currentStyles = heroStylesData.find(styles => styles.id === subject.heroStyles);
      setHeroStyles(currentStyles)
    }

  }, [subject]);


  const classes = classNames(rootClassName || css.root, className);

  const title = <FormattedMessage id="SectionOnlineTeachersForHire.title" />;
  const titleWithState = <FormattedMessage id="SectionOnlineTeachersForHire.titleWithState" values={{state: state?.label }} />;
  const titleWithStateAndSubject = <FormattedMessage id="SectionOnlineTeachersForHire.titleWithStateAndSubject" values={{state: state?.label, subject: subject?.parent }} />;

  const gradientContainerClasses = (state && !subject) ?
    classNames(css.gradientContainer,  css.gradientContainerWithState) : (state && subject )?
      classNames(css.gradientContainer,  css.gradientContainerWithStateAndSubject) : classNames(css.gradientContainer);

  return (
    <div className={classes}>
      <div style={{backgroundColor: heroStyles.backgroundColor}} className={gradientContainerClasses}>
        <div className={css.heroContent}>
          <div className={(state && !subject) ? classNames(css.heroContentText, css.heroContentTextBlack) : classNames(css.heroContentText) }>
            <h1
              className={subject ? classNames(css.heroMainTitle, css.heroMainTitleSubject) : classNames(css.heroMainTitle)}>
              {content?.heroTitle ?
                content.heroTitle :
                state && !subject ?
                  titleWithState :
                  state && subject ?
                    titleWithStateAndSubject :
                    title
              }
            </h1>
            <h2 className={classNames(css.heroSubTitle)}>
              {content?.heroDescription ?
                content.heroDescription :
                state && !subject ?
                <FormattedMessage id="SectionOnlineTeachersForHire.stateSubtitle" values={{state: state?.label }} /> :
                  state && subject ?
                <FormattedMessage id="SectionOnlineTeachersForHire.subjectSubtitle" values={{state: state?.label, subject: subject?.parent }} /> :
                <FormattedMessage id="SectionOnlineTeachersForHire.subtitle" />
              }
            </h2>
            {currentUser && !isTeacher && (
              <NamedLink
                style={{backgroundColor: heroStyles.buttonColor}}
                name="NewJobPage"
                className={state && !subject ? classNames(css.heroButton, css.heroStateButton) : css.heroButton}
              >
                <FormattedMessage id="SectionOnlineTeachersForHire.button" />
              </NamedLink>
            )}
            {!currentUser && (
              <Button
                style={{backgroundColor: heroStyles.buttonColor}}
                className={state && !subject ? classNames(css.heroButton, css.heroStateButton) : css.heroButton}
                onClick={handleGetStarted}>
                <FormattedMessage id="SectionOnlineTeachersForHire.button" />
              </Button>
            )}
          </div>

          <div className={css.heroContentImg}>
            <HeroImage src={heroStyles.imgSrc} />
          </div>
        </div>
      </div>
    </div>
  )
}

const HeroImage = (props) => {
  const { imageIndex, src = heroStylesData[0].imgSrc } = props;
  const i = imageIndex === -1 ? 0 : imageIndex;

  return <img src={src} alt='AllCourse' />;
};

export default SectionHero;
